import { Component, OnInit, OnDestroy, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { NbWindowService, NbWindowState, NbWindowRef } from '@nebular/theme';

@Component({
  selector: 'ngx-popup-tempalate',
  templateUrl: './popup-tempalate.component.html',
  styleUrls: ['./popup-tempalate.component.scss'],
})
export class PopupTempalateComponent implements OnInit, OnDestroy {
  @ViewChild('mPopup', { static: true, read: TemplateRef }) mPopup: TemplateRef<any>;

  isMobile = window['mobileCheck']();
  @Input() ignoreMobileStatus = 'false';
  @Input() headerTemplate = false;
  @Input() headerImage =  '';//'assets/images/popup2Header.svg';
  @Input() padding =  this.isMobile ? '0px' : '32px';
  @Input() buttonText = '';
  @Input() header = '';
  @Input() content = '';
  @Input() contentHeader = '';
  @Input() contentText = '';
  @Input() contentImage = '';
  @Input() maxWidth = '';
  @Input() width = '';
  @Input() height = '';
  @Input() startAnimation = 'false';
  @Input() isChecked = true;
  @Input() checkBoxText = '';
  @Input() closeOnClickOut = true;

  @Output() next = new EventEmitter<any>();
  @Output() close = new EventEmitter<any>();
  @Output() isCheckedChange = new EventEmitter<Boolean>();

  windowRef: NbWindowRef;
  constructor(private windowService: NbWindowService,
  ) {

  }

  nextClick() {
    this.next.emit();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.windowRef?.close();
  }

  closeWindow() {
    this.close.emit();
    this.windowRef.close();
  }

  open() {
    let image = new Image(); 
    if(this.contentImage){image.src= this.contentImage;}
      
    image = new Image(); 
     
    if(this.headerImage){image.src= this.headerImage;}
    let winClass = 'mobileFullScreen';

    if(this.ignoreMobileStatus == 'true')
    {
      this.isMobile = false;
      this.padding='32px';
      winClass = '';
    }
    //else{winClass = 'mobileFullScreen';}
    
    
    this.windowRef = this.windowService.open(this.mPopup,
      {
        title: '',
        hasBackdrop: true,
        closeOnBackdropClick: false,
        initialState: NbWindowState.FULL_SCREEN,
        closeOnEsc: false,
        windowClass: winClass,
        context: {
          text: 'https://drive.google.com/viewerng/viewer?embedded=true&url=https://list-upload-files-test.s3.us-east-2.amazonaws.com/18938d565a8c849dbb04ed389b203da9.pdf',
        },
      },
    );
    return this.windowRef;

  }
}
